import Extension from "../base/extension";

/**
 * Gates purchase UI by IP-detected country (Shopify browsing context).
 *
 * localization.country alone is not enough when Markets only includes the UK —
 * every visitor is assigned GB regardless of VPN/IP. This extension fetches the
 * detected country and toggles [data-purchase-actions] /
 * [data-purchase-unavailable] inside [data-purchase-gate].
 */
class PurchaseGate extends Extension {
  constructor(name) {
    super(name);
  }

  async onReady() {
    const gates = document.querySelectorAll("[data-purchase-gate]");
    if (!gates.length) return;

    try {
      const country_code = await this.fetchDetectedCountry();
      gates.forEach((gate) => this.applyGate(gate, country_code));
    } catch (error) {
      console.warn(this.logPrefix, "Could not detect country", error);
    }
  }

  /**
   * Fresh IP geolocation from Shopify (not cookie-cached).
   * @returns {Promise<string|null>} ISO country code, e.g. "GB"
   */
  async fetchDetectedCountry() {
    const response = await fetch(window.routes.browsing_context_suggestions_url);
    const result = await response.json();
    const handle = result?.detected_values?.country?.handle;
    return handle ? String(handle).toUpperCase() : null;
  }

  /**
   * @param {HTMLElement} gate
   * @param {string|null} country_code
   */
  applyGate(gate, country_code) {
    const allowed = (gate.dataset.shippableCountries || "GB")
      .split(",")
      .map((code) => code.trim().toUpperCase())
      .filter(Boolean);

    const purchase_enabled = country_code != null && allowed.includes(country_code);

    gate.querySelectorAll("[data-purchase-actions]").forEach((element) => {
      element.classList.toggle("d-none", !purchase_enabled);
    });

    gate.querySelectorAll("[data-purchase-unavailable]").forEach((element) => {
      element.classList.toggle("d-none", purchase_enabled);
    });

    gate.dataset.purchaseReady = "true";
    gate.dataset.detectedCountry = country_code || "";
  }
}

export default PurchaseGate;
